export default "__VITE_PUBLIC_ASSET__dc0abc3a__"